import * as React from 'react';
import { Container, Button, FormGroup, Input, Label, Row, Col, Badge } from 'reactstrap';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import * as Clients from '../../client/ApiClient';
import { connect } from 'react-redux';
import { ApplicationState } from 'store';
import { HubConnection, HubConnectionBuilder } from '@microsoft/signalr'
import { enqueueNotification } from "../../store/Notifications"
import { store } from '../../AppContext';
import { DataCell, DataRow, DataTable } from '../basic/DataTable';
import { SecureContainer } from '../basic/Authentication';
import * as Roles from 'constants/Roles';
import * as SourceSystem from 'constants/SourceSystem';

interface MergeToolPageState {
    agencyNumbers: {
        agencyNo: string,
        selected: boolean
    }[];
    merge: string;
    buttonLock: boolean;
    mergeLock: boolean;
    timeout: any;
    hubConnection: HubConnection | null;
    status: any;
    reportStatus: any;
    loading: boolean;
    loadingRollback: boolean;
    timings: Clients.TimingsModel[];
    items: Clients.TimingsModel[];
    timingSelected: string;
    sort: boolean;
    sortTimings: boolean;
    currentConversion: Clients.ConversionModel | null;
    currentMerge: Clients.CurrentMergeModel | null;
    isStageCompleted: boolean;
}
interface MergeToolArgs {
    conversionId: string,
}

type MergeToolProps = RouteComponentProps<MergeToolArgs> & {
    currentUser: Clients.IUserLoginDetailsModel | undefined,
};

class MergeToolPage extends React.Component<MergeToolProps, MergeToolPageState>{

    private conversionClient: Clients.ConversionClient = new Clients.ConversionClient();
    private conversonGenericClient: Clients.GenericClient = new Clients.GenericClient();
    private executions: Clients.ExecutionsClient = new Clients.ExecutionsClient();
    private mergeClient: Clients.MergeMapClient = new Clients.MergeMapClient();

    constructor(props: Readonly<MergeToolProps>) {
        super(props)
        this.state = {
            agencyNumbers: [],
            merge: '',
            buttonLock: true,
            mergeLock: true,
            timeout: null,
            hubConnection: null,
            status: null,
            reportStatus: null,
            loading: false,
            loadingRollback: false,
            timings: [],
            items: [],
            timingSelected: '',
            sort: true,
            sortTimings: true,
            currentConversion: null,
            currentMerge: null,
            isStageCompleted: false,
        }
    }

    componentDidMount() {
        this.getConnections(0);
        this.refreshCall();
        this.getTimings();
        this.buttonLock();
        this.getExecution();
        this.currentConversion();
        this.currentMerge();
    }

    refreshCall() {
        clearInterval(this.state.timeout);
        const link = '/executions';
        const hubConnection = new HubConnectionBuilder().withUrl(link).withAutomaticReconnect().build();
        this.setState({ hubConnection }, () => {
            this.state.hubConnection!
                .start()
                .then(() => console.log("Connection started for Merge"))
                .catch(() => console.log("there is an error"));

            this.state.hubConnection!.on("Merge", (execution: Clients.ExecutionsModel) => {
                this.buttonLock();
                this.currentMerge();
                clearInterval(this.state.timeout);
                if ((execution.description === "Succeeded" || execution.description === "Completed") && execution.userId === this.props.currentUser!.id) {
                    store.dispatch(enqueueNotification({ type: 'success', message: execution.clientDescription + ' - ' + execution.conversionDescription + ' - ' + execution.title + ' - ' + execution.description }))
                }
                else if ((execution.description === "Failed" || execution.description === "Canceled" || execution.description === "Ended Unexpectedly" || execution.description === "Stopping") && execution.userId === this.props.currentUser!.id) {
                    const color = execution.description === "Canceled" ? 'warning' : 'error';
                    store.dispatch(enqueueNotification({ type: color, message: execution.clientDescription + ' - ' + execution.conversionDescription + ' - ' + execution.title + ' - ' + execution.description }))
                }
                if (execution.conversionId === this.props.match.params.conversionId && !execution.packageName!.includes("Reporting")) {
                    const name = execution.packageName === 'Orchestration-StageValidateAndLoad.dtsx' ? 'Full Merge to Target' :
                        execution.packageName === 'Orchestration-StageAndValidate.dtsx' ? 'Merge to Stage' :
                            execution.packageName === 'Orchestration-LoadData.dtsx' ? 'Write Stage to Target' :
                                execution.packageName === 'Orchestration-Rollback.dtsx' ? 'Remove Migrated Data' : ''

                    let packageName: string = '';
                    this.mergeClient.getMostRecentPackage(this.props.match.params.conversionId)
                        .then((response) => {
                            if (response && response.length > 0) {
                                packageName = response;
                            }
                        })
                        .catch(error => packageName = '')

                    if (execution.endTime) {
                        clearInterval(this.state.timeout);
                        this.setState({
                            timeout: null, status: null
                        }, () => {
                            const status = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name, packageName)
                            this.setState({ status })
                        })
                    } else if (execution.estimatedFinish) {
                        this.setState({
                            timeout: setInterval(() => {
                                const status = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name, packageName)
                                this.setState({ status })
                            }, 1000)
                        })
                    } else if (execution.status === 2 && execution.startTime === null) {
                        clearInterval(this.state.timeout);
                        const status = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name, packageName)
                        if (execution.packageName === 'Orchestration-Rollback.dtsx') {
                            this.setState({ status, loadingRollback: true })
                        } else {
                            this.setState({ status, loading: true })
                        }
                    } else {
                        clearInterval(this.state.timeout);
                    }
                }
                else if (execution.conversionId === this.props.match.params.conversionId && execution.packageName!.includes("Reporting")) {
                    const name = "Merge Reporting"
                    if (execution.endTime) {
                        clearInterval(this.state.timeout);
                        this.setState({
                            timeout: null, reportStatus: null
                        }, () => {
                            const reportStatus = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name)
                            this.setState({ reportStatus })
                        })
                    } else if (execution.estimatedFinish) {
                        this.setState({
                            timeout: setInterval(() => {
                                const reportStatus = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name)
                                this.setState({ reportStatus })
                            }, 1000)
                        })
                    } else if (execution.status === 2 && execution.startTime === null) {
                        clearInterval(this.state.timeout);
                        const reportStatus = this.setStatusForMerge(execution!.estimatedFinish, execution!.description, execution!.endTime, name)
                        this.setState({ reportStatus })
                    } else {
                        clearInterval(this.state.timeout);
                    }
                }

            });
        })
    }

    componentWillUnmount() {
        this.state.hubConnection!.stop();
        this.setState = (_state, _callback) => {
            return;
        };
    }

    getConnections = (connectionId: number) => {
        const params = this.props.match.params
        this.conversionClient.getConnectionsAll(params.conversionId, connectionId)
            .then(response => {
                const agencyNumbers: { agencyNo: string, selected: boolean }[] = []
                response!.forEach(r => {
                    agencyNumbers.push({ agencyNo: r.name!, selected: true })
                })
                this.setState({ agencyNumbers })
            })
            .catch(error => { })
    }

    currentConversion = () => {
        this.conversionClient.get(this.props.match.params.conversionId)
            .then(response => {
                if (response) {
                    this.setState({ currentConversion: response });
                }
            })
            .catch(error => { })
    }

    currentMerge = () => {
        this.mergeClient.getCurrentMergeRun(this.props.match.params.conversionId)
            .then(response => {
                if (response) {
                    this.setState({ currentMerge: response });
                }
            })
            .catch(error => { })
    }

    agencyNumber = (agencyNo: string) => {
        const agencyNumbers = this.state.agencyNumbers.map(
            a => a.agencyNo === agencyNo
                ? ({
                    ...a,
                    selected: !a.selected,
                })
                : a
        )
        this.setState({ agencyNumbers });
    }

    merge = () => {
        const conversionId = this.props.match.params.conversionId
        const userId = this.props.currentUser!.id
        if (conversionId && userId) {
            const merge = this.state.merge
            const name = merge === 'merge' ? 'Full Merge to Target' :
                merge === 'stage' ? 'Merge to Stage' :
                    merge === 'load' ? 'Write Stage to Target' : ''
            const status = <h5> <Badge color={"primary"}>{name} - Estimate: Pending - Status: Running </Badge></h5>
            this.setState({ buttonLock: true, loading: true, status })
            this.conversonGenericClient.runMergeAction(conversionId, userId, this.state.merge)
                .then()
                .catch((err) => {
                    console.log(err)
                    this.setState({ buttonLock: false, loading: false, loadingRollback: false, status: null }, () => {
                        this.getExecution();
                    })
                });
        }
    }

    remove = () => {
        const conversionId = this.props.match.params.conversionId
        const userId = this.props.currentUser!.id
        if (conversionId && userId) {
            if (confirm("This action will delete everything processed by the conversion from the customer’s Production DB. In order to proceed we must have written signoff from the customer, take their Production database offline etc. (cannot be done programmatically)")) {
                if (confirm("Has the database been taken offline? Have you obtained customer signoff/approval for this action?")) {
                    const status = <h5> <Badge color={"primary"}>Remove Migrated Data - Estimate: Pending - Status: Running</Badge></h5>
                    this.setState({ buttonLock: true, loadingRollback: true, status })
                    this.conversonGenericClient.runMergeAction(conversionId, userId, "remove")
                        .then()
                        .catch((err) => {
                            console.log(err)
                            this.setState({ buttonLock: false, loading: false, loadingRollback: false, status: null }, () => {
                                this.getExecution();
                            })
                        });
                }
            }
        }
    }

    buttonLock = () => {
        this.mergeLock();
        const conversionId = this.props.match.params.conversionId;
        this.executions.listExecutionsAllTierBoolean(conversionId)
            .then((response) => {
                if (response) {
                    this.setState({ buttonLock: response.isLocked })
                }
            })
            .catch(error => { })
    }


    mergeLock = () => {
        const conversionId = this.props.match.params.conversionId;
        this.mergeClient.mergeLock(conversionId)
            .then((response) => {
                this.setState({ mergeLock: response })
            })
            .catch(error => { })
    }

    getExecution = () => {
        this.executions!.listExecutions(this.props.match.params.conversionId)
            .then(results => {
                if (results!.length === 0) {
                    this.setState({
                        loading: false,
                        loadingRollback: false,
                        status: null,
                        reportStatus: null,
                    })
                }
                else {
                    const tierPrep = results!.filter(r => r.packageName!.includes('Orchestration') && r.packageName !== 'Orchestration-Map.dtsx' && r.packageName !== 'Orchestration-Reporting.dtsx')
                    const reports = results!.filter(r => r.packageName === 'Orchestration-Reporting.dtsx')
                    const stageExecutions = results!.filter(r => r.packageName === 'Orchestration-StageAndValidate.dtsx').sort((a, b) => b.executionId - a.executionId);
                    let isStageCompleted = false;
                    if (stageExecutions.length > 0) {
                        const recentExecution = stageExecutions[0];
                        isStageCompleted = recentExecution.status === 7;
                    }
                    this.setState({ isStageCompleted });
                    let lastExecution = tierPrep![tierPrep!.length - 1];
                    let lastReport = reports![reports!.length - 1];
                    if (lastExecution) {
                        if (lastExecution.endTime) clearInterval(this.state.timeout);
                        const endTime = lastExecution.endTime;

                        const name = lastExecution.packageName === 'Orchestration-StageValidateAndLoad.dtsx' ? 'Full Merge to Target' :
                            lastExecution.packageName === 'Orchestration-StageAndValidate.dtsx' ? 'Merge to Stage' :
                                lastExecution.packageName === 'Orchestration-LoadData.dtsx' ? 'Write Stage to Target' :
                                    lastExecution.packageName === 'Orchestration-Rollback.dtsx' ? 'Remove Migrated Data' : ''
                        const merge = lastExecution.packageName === 'Orchestration-StageValidateAndLoad.dtsx' && endTime === undefined ? 'merge' :
                            lastExecution.packageName === 'Orchestration-StageAndValidate.dtsx' && endTime === undefined ? 'stage' :
                                lastExecution.packageName === 'Orchestration-LoadData.dtsx' && endTime === undefined ? 'load' :
                                    lastExecution.packageName === 'Orchestration-Rollback.dtsx' && endTime === undefined ? 'Remove Migrated Data' : '';

                        const estimatedFinish = lastExecution.estimatedFinish;

                        let packageName: string = '';

                        this.mergeClient.getMostRecentPackage(this.props.match.params.conversionId)
                            .then((response) => {
                                if (response && response.length > 0) {
                                    packageName = response;
                                }
                            })
                            .catch(error => packageName = '')

                        let reportStatus = lastReport && this.setStatusForMerge(lastReport.estimatedFinish, lastReport.description!, lastReport.endTime, 'Merge Reports')
                        let status = this.setStatusForMerge(estimatedFinish, lastExecution.description!, endTime, name, packageName)
                        this.setState({ status, reportStatus, merge })

                        if (endTime === undefined) {
                            this.setState({
                                timeout: setInterval(() => {
                                    status = this.setStatusForMerge(estimatedFinish, lastExecution.description!, endTime, name, packageName)
                                    if (lastExecution.packageName === 'Orchestration-Rollback.dtsx') {
                                        this.setState({ status, loadingRollback: true })
                                    } else {
                                        this.setState({ status, loading: true })
                                    }
                                }, 1000)
                            })
                        } else if (lastReport.endTime === undefined) {
                            this.setState({
                                timeout: setInterval(() => {
                                    reportStatus = lastReport && this.setStatusForMerge(lastReport.estimatedFinish, lastReport.description!, lastReport.endTime, 'Merge Reports')
                                    this.setState({ reportStatus, loading: true })
                                }, 1000)
                            })
                        }
                    }
                }
            })
            .catch(e => { console.log(e) })
    }

    private setStatusForMerge(timeEstimate: Date | undefined, status: string | undefined, endTime: Date | undefined, name: string, packageName: string = '') {
        let color = ""
        if (endTime) {
            clearInterval(this.state.timeout);
            const dt = new Date(endTime);
            const day = dt.getDate(),
                month = dt.getMonth(),
                year = dt.getFullYear(),
                minutes = (dt.getMinutes() < 10 ? '0' : "") + dt.getMinutes();
            let hours = dt.getHours();
            const period = (hours < 12) ? 'AM' : 'PM';
            if (period === 'PM' && hours !== 12) hours = hours - 12;
            if (hours === 0) hours = 12;
            if (status === "Failed" || status === "Ended Unexpectedly") {
                color = "danger"
            } else if (status === "Canceled") {
                color = "warning"
            } else if (status === "Succeeded" || status === "Completed") {
                color = "success"
            }
            this.setState({ loading: false, loadingRollback: false });
            return <h5> <Badge color={color}> {name} completed on {
                `${(month + 1)}/${day}/${year} ${hours}:${minutes} ${period}`
            } - Status: {status} </Badge></h5>
        } else {
            color = "primary"
            const now = new Date().valueOf();
            const estimate = timeEstimate ? new Date(timeEstimate).valueOf() : now;
            const timeRemain: number = (estimate - now) / 60000;
            const timeLeft = timeEstimate && timeRemain > 0 ? `${timeRemain.toFixed(2)} minutes` : "Pending";
            if (name === 'Remove Migrated Data') {
                this.setState({ loadingRollback: true })
            } else {
                this.setState({ loading: true })
            }
            return <h5> <Badge color={color}>{name} - Estimate: {timeLeft} {packageName ? `- Current Package: ${packageName} ` : ''}- Status: {status} </Badge></h5>
        }
    }

    getTimings = () => {
        this.mergeClient.getLogTimings(this.props.match.params.conversionId)
            .then((response) => {
                if (response) {
                    this.setState({ timings: response }, () => { this.sortTimings('logSequenceId') })
                }
            })
            .catch(error => { })

        this.mergeClient.getLogTimeActions('mergeRuns', this.props.match.params.conversionId)
            .then((response) => {
                if (response) {
                    this.setState({ items: response }, () => { this.sort('startTimestamp') })
                }
            })
            .catch(error => { })
    }

    sort(column: string) {
        const items = this.state.items.sort((a: any, b: any) => {
            let x = a[column] !== null ? a[column] : ''
            let y = b[column] !== null ? b[column] : ''
            y = typeof y === "string" ? y.toLowerCase().trim() : y
            x = typeof x === "string" ? x.toLowerCase().trim() : x
            if (this.state.sort) {
                if (x < y) { return -1; }
                if (x > y) { return 1; }
            } else {
                if (x > y) { return -1; }
                if (x < y) { return 1; }
            }
            return 0
        })
        this.setState({ sort: !this.state.sort, items });
    }

    sortTimings(column: string) {
        const timings = this.state.timings.sort((a: any, b: any) => {
            let x = a[column] !== null ? a[column] : ''
            let y = b[column] !== null ? b[column] : ''
            y = typeof y === "string" ? y.toLowerCase() : y
            x = typeof x === "string" ? x.toLowerCase() : x
            if (this.state.sortTimings) {
                if (x < y) { return -1; }
                if (x > y) { return 1; }
            } else {
                if (x > y) { return -1; }
                if (x < y) { return 1; }
            }
            return 0
        })
        this.setState({ sortTimings: !this.state.sortTimings, timings });
    }

    handleHover = () => {
        const status = this.state.status.props.children[1].props.children[1];
        const packageName = status === 'Full Merge to Target' ? 'Orchestration-StageValidateAndLoad.dtsx' :
            status === 'Merge to Stage' ? 'Orchestration-StageAndValidate.dtsx' :
                status === 'Write Stage to Target' ? 'Orchestration-LoadData.dtsx' : 'Orchestration-Rollback.dtsx'
        if (this.state.status.props.children[1].props.color.toString() == "danger") {
            this.executions!.listExecutionErrorDetail(this.props.match.params.conversionId, packageName)
                .then(results => {
                    if (results!.length != 0)
                        alert(results);
                })
                .catch(e => { console.log(e) })
        }
    };

    public render() {
        const items = this.state.items
        //.filter(i => {
        //    return i.agencyNo === this.state.timingSelected ||
        //        this.state.timingSelected === ''
        //})
        const currentMerge = this.state.currentMerge
        const removeGate = currentMerge !== null ? currentMerge!.loadFinishTimestamp === undefined || (currentMerge!.rollbackFinishTimestamp !== undefined && !currentMerge.rollbackFailed) : true;
        return (
            <>
                <br />
                <h3 className='mapping-body-header'>Merge To Staging or Target</h3>
                <br />
                <Container>
                    <br />
                    <Row>
                        <Col md={{ size: 5 }}>
                            <legend>Select Source(s) to Merge</legend>
                            {this.state.agencyNumbers.map(
                                (a, i) => {
                                    return (
                                        <FormGroup check className="agencyCheck" key={i}>
                                            <Label check>
                                                <Input type="checkbox" checked={a.selected} onChange={() => this.agencyNumber(a.agencyNo)} disabled={true} />{' '}
                                                {a.agencyNo}
                                            </Label>
                                        </FormGroup>
                                    )
                                })}
                        </Col>
                        <Col md={{ size: 5 }}>
                            <legend>Select Action</legend>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="radio1" value={this.state.merge} checked={this.state.merge === 'stage'} disabled={this.state.loading || this.state.buttonLock || this.state.mergeLock} onChange={() => this.setState({ merge: 'stage' })} />{' '}
                                    Merge to Stage
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="radio1" value={this.state.merge} checked={this.state.merge === 'load'} disabled={this.state.loading || this.state.buttonLock || this.state.mergeLock || !this.state.isStageCompleted} onChange={() => this.setState({ merge: 'load' })} />{' '}
                                    Write Stage to Target
                                </Label>
                            </FormGroup>
                            <FormGroup check>
                                <Label check>
                                    <Input type="radio" name="radio1" value={this.state.merge} checked={this.state.merge === 'merge'} disabled={this.state.loading || this.state.buttonLock || this.state.mergeLock} onChange={() => this.setState({ merge: 'merge' })} />{' '}
                                    Full Merge to Target
                                </Label>
                            </FormGroup>
                        </Col>
                        <Col>
                            <Row>
                                <Button
                                    disabled={this.state.loading || this.state.merge === '' || !this.state.agencyNumbers.some(a => a.selected) || this.state.buttonLock || this.state.mergeLock}
                                    className="toolbar-link-button-primary mergeButton"
                                    onClick={() => this.merge()}>
                                    Run Merge
                                </Button>
                                {this.state.loading && <img className='loading-indicator' alt="loader" src={'loader.gif'} />}
                            </Row>
                            {this.state.currentConversion && this.state.currentConversion!.conversionTypeId.toUpperCase() === SourceSystem.ndtAms360ToAMS360Id &&
                                < SecureContainer roles={[
                                    Roles.developerAdministrationRoleId
                                ]}>
                                    <Row>
                                        <Button
                                            disabled={this.state.loadingRollback || this.state.buttonLock || removeGate}
                                            className="toolbar-link-button-primary mergeButton"
                                            onClick={() => this.remove()}>
                                            Remove Data
                                        </Button>
                                        {this.state.loadingRollback && <img className='loading-indicator' alt="loader" src={'loader.gif'} />}
                                    </Row>
                                </SecureContainer>}
                        </Col>
                    </Row>

                    <br />
                    <hr />
                    <br />
                    <Row>
                        <Col md={{ size: 2 }}>
                            <h4>Merge Status: </h4>
                        </Col>
                        <Col md={{ size: 5 }}>
                            <div onClick={this.handleHover} className='pointer'>
                                {this.state.status}
                            </div>
                            <div onClick={this.handleHover} className='pointer'>
                                {this.state.reportStatus}
                            </div>
                        </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col md={{ size: 3 }}>*/}
                    {/*        <select className="custom-select" name='mappedValue' onChange={(e) => { this.setState({ timingSelected: e.target.value }) }}>*/}
                    {/*            <option value=''>Select Agency</option>*/}
                    {/*            {this.state.agencyNumbers.map((a, i) =>*/}
                    {/*                <option value={a.agencyNo} key={i}>{a.agencyNo}</option>*/}
                    {/*            )}*/}
                    {/*        </select>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    <Row>
                        <Col>
                            <DataTable>
                                <thead>
                                    <tr>
                                        <th onClick={() => this.sort('mergeSequenceId')}>Sequence # <i className="fa fa-sort"></i></th>
                                        {/*<th onClick={() => this.sort('agencyNo')}>Agency No <i className="fa fa-sort"></i></th>*/}
                                        <th onClick={() => this.sort('action')}>Action <i className="fa fa-sort"></i></th>
                                        <th onClick={() => this.sort('startTimestamp')}>Start Time <i className="fa fa-sort"></i></th>
                                        <th onClick={() => this.sort('finishTimestamp')}>End Time<i className="fa fa-sort"></i></th>
                                        {/*<th onClick={() => this.sortTimings('isRunning')}>Running <i className="fa fa-sort"></i></th>*/}
                                        <th onClick={() => this.sortTimings('status')}>Status <i className="fa fa-sort"></i></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {items.map((item, index) => {
                                        if (item.startTimestamp)
                                            return <>
                                                <DataRow id={item.mergeSequenceId.toString()} key={index}>
                                                    <DataCell>{item.mergeSequenceId}</DataCell>
                                                    {/*<DataCell>{item.agencyNo}</DataCell>*/}
                                                    <DataCell>{item.action}</DataCell>
                                                    <DataCell>{item.startTimestamp && item.startTimestamp!.toLocaleString()}</DataCell>
                                                    <DataCell>{item.finishTimestamp && item.finishTimestamp!.toLocaleString()}</DataCell>
                                                    {/*<DataCell className='checkbox-column'>*/}
                                                    {/*    {item.isRunning === 0 && item.finishTimestamp !== null ? < p className='mapped'>&#x2705;</p> : item.isRunning === 1 ? <img className='loading-indicator' alt="loader" src={'loader.gif'} /> : null}*/}
                                                    {/*</DataCell>*/}
                                                    <DataCell className='checkbox-column'>
                                                        {item.status === 7 ? < p className='mapped'>&#x2705;</p> : item.status === 4 ? < p className='mapped'>&#x274C;</p> : item.status === 2 ? <img className='loading-indicator' alt="loader" src={'loader.gif'} /> : null}
                                                    </DataCell>
                                                </DataRow>
                                            </>
                                    })}
                                </tbody>
                            </DataTable>
                        </Col>
                    </Row>
                    {/*<Row>*/}
                    {/*    <Col>*/}
                    {/*        <DataTable>*/}
                    {/*            <thead>*/}
                    {/*                <tr className="nonFullWidthRow">*/}
                    {/*                    <th onClick={() => this.sortTimings('logSequenceId')}>Sequence # <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('agencyNo')}>Agency No <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('action')}>Action <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('tableName')}>Table Name <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('recordCount')}>Record Count <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('executionTimeInMilliseconds')}>Execution Time <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('isRunning')}>Running <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('startTimestamp')}>Start Time <i className="fa fa-sort"></i></th>*/}
                    {/*                    <th onClick={() => this.sortTimings('finishTimestamp')}>End Time<i className="fa fa-sort"></i></th>*/}
                    {/*                </tr>*/}
                    {/*            </thead>*/}
                    {/*            <tbody>*/}
                    {/*                {timings.map((item, index) => {*/}
                    {/*                    return <>*/}
                    {/*                        <DataRow id={item.mergeSequenceId.toString()} key={index}>*/}
                    {/*                            <DataCell>{item.logSequenceId}</DataCell>*/}
                    {/*                            <DataCell>{item.agencyNo}</DataCell>*/}
                    {/*                            <DataCell>{item.action}</DataCell>*/}
                    {/*                            <DataCell>{item.tableName}</DataCell>*/}
                    {/*                            <DataCell>{item.recordCount}</DataCell>*/}
                    {/*                            <DataCell>{item.executionTimeInMilliseconds}</DataCell>*/}
                    {/*                            <DataCell>{item.isRunning}</DataCell>*/}
                    {/*                            <DataCell>{item.startTimestamp.toLocaleString()}</DataCell>*/}
                    {/*                            <DataCell>{item.finishTimestamp.toLocaleString()}</DataCell>*/}
                    {/*                        </DataRow>*/}
                    {/*                    </>*/}
                    {/*                })}*/}
                    {/*            </tbody>*/}
                    {/*        </DataTable>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                </Container>
            </>
        )
    }
}

export default connect(
    (state: ApplicationState) => {
        return {
            currentUser: state.authentication && state.authentication.currentUser,
        }
    },
)(withRouter(MergeToolPage));